import { alpha, Theme } from '@mui/material/styles';
import { glassSurface } from '../glass';

// ----------------------------------------------------------------------

export default function AppBar(theme: Theme) {
  const isLight = theme.palette.mode === 'light';

  return {
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          ...glassSurface(theme, 'strong'),
          color: theme.palette.text.primary,
          border: 'none',
          borderBottom: `1px solid ${alpha(theme.palette.common.white, isLight ? 0.6 : 0.08)}`,
          boxShadow: isLight ? theme.customShadows.z12 : theme.customShadows.z16,
        },
      },
    },
  };
}
